import PropTypes from "prop-types";
import React from "react";
import SubscribeEmailTwo from "../../components/newsletter/SubscribeEmailTwo";
const Newsletter = ({
  bgColorClass,
  spaceBottomClass,
  spaceLeftClass,
  spaceRightClass,
  spaceTopClass,
}) => {
  return (
    <div
      className={`subscribe-area ${bgColorClass ? bgColorClass : ""} ${
        spaceBottomClass ? spaceBottomClass : ""
      }
      ${spaceTopClass ? spaceTopClass : ""}
      ${spaceLeftClass ? spaceLeftClass : ""}  ${
        spaceRightClass ? spaceRightClass : ""
      }`}
      style={{
        backgroundImage: `url(${
          process.env.PUBLIC_URL + "/assets/img/bg/subscription.jpg"
        })`,
      }}
    >
      <div className="container">
        <div className="row">
          <div className="subscribe-style-2 text-center d-flex flex-row justify-content-center w-100 align-items-center flex-wrap">
            <div className={`section-title text-center  mb-30`}>
              <h2 className="mr-20" style={{
                lineHeight: "4rem"
              }}>Suscribite para ser parte de nuestra comunidad</h2>
            </div>
            <div className="mb-30">
              <p>Recibe GRATIS la Guia digital: 5 claves para que el paseo en familia sea un éxito</p>
            </div>
            {/* subscription form */}
            <SubscribeEmailTwo
              // mailchimpUrl="//brujaslab.us7.list-manage.com/subscribe/post?u=024c774ef77251dc21150c195&amp;id=4e1ce4461e"
              spaceTopClass="mt-35"
              mailchimpUrl=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

Newsletter.propTypes = {
  bgColorClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
};

export default Newsletter;
